module.exports = __webpack_public_path__ + "img/html.b0936f1.svg";